import * as React from 'react';
import { useEffect } from 'react';
import type { FC } from 'react';
import { filtersPinned, jumpToTop } from 'brand_xo/pageScroll';
import BannerToggle from './BannerToggle';
import ResetSearch from './ResetSearch';
import usePageLayout from './usePageLayout';
import { rememberBannerHidden, clearSidebarSelection } from './pageLayout';
import type { BannerProps } from './types';

// The end of the filter row: one place, two buttons - a search owns it.
const SearchEnd: FC<{
  searchActive: boolean;
  searchFieldShown: boolean;
  banner: BannerProps;
  onReset: () => void;
}> = ({ searchActive, searchFieldShown, banner, onReset }) => {
  const { layout, enterSearch, leaveSearch, setBannerHidden } = usePageLayout({
    searching: searchActive,
    bannerHidden: banner.hidden,
  });

  useEffect(() => {
    if (searchFieldShown) enterSearch();
  }, [searchFieldShown]);

  // Back to all games at `/` (onReset clears the filters), and the banner as the visitor left it.
  const resetSearch = () => {
    onReset();
    leaveSearch();
    clearSidebarSelection();
  };

  const toggleBanner = () => {
    const hidden = !layout.bannerHidden;
    rememberBannerHidden(hidden, banner);
    setBannerHidden(hidden);
    // From the pinned row: to the banner, or to the list that the hidden banner leaves at the top.
    if (filtersPinned()) jumpToTop();
  };

  return (
    <div className="rs-flex-item filters_end">
      {layout.searching ? (
        <ResetSearch onReset={resetSearch} />
      ) : (
        <BannerToggle hidden={layout.bannerHidden} onToggle={toggleBanner} />
      )}
    </div>
  );
};

export default SearchEnd;
